
import { defineComponent } from 'vue'

/**
 * Confirm report delete modal
 */
export default defineComponent({
  name: 'ReportDeleteConfirm',
  props: {
    reportLabel: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
})
